import { render } from "./Member_address.vue?vue&type=template&id=535b2264"
import script from "./Member_address.vue?vue&type=script&lang=js"
export * from "./Member_address.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__